import {
Component,
Injector,
Optional
} from '@angular/core';
import {CommonModule} from "@angular/common";
import { WmsTranscludeDirective } from '../../page/wms-transclude/wms-transclude.directive';

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, styler, register } from "@wm/components-base";
import { generateGUId, runtimeEventManager, setCSS } from '@wm/core';

const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-pagedialog',
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmPageDialog]',
  template: `
  <div class="app-view dialog-view clearfix">
    <div class="app-dialog modal-dialog app-page-dialog" [ngStyle]="{width: width}">
      <div class="modal-content">
        <div class="app-dialog-header modal-header">
          <button aria-label="Close" class="app-dialog-close close" [ngClass]="{'btn-text': isPrism}" title="Close">
            <span class="app-icon wi wi-clear" aria-hidden="true"></span>
          </button>
          <!-- Change the header tag based on the heading level -->
          <ng-container [ngSwitch]="headinglevel">
            <ng-container *ngSwitchCase="'h1'">
              <h1 class="app-dialog-title modal-title">
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              </h1>
            </ng-container>
            <ng-container *ngSwitchCase="'h2'">
              <h2 class="app-dialog-title modal-title">
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              </h2>
            </ng-container>
            <ng-container *ngSwitchCase="'h3'">
              <h3 class="app-dialog-title modal-title">
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              </h3>
            </ng-container>
            <ng-container *ngSwitchCase="'h4'">
              <h4 class="app-dialog-title modal-title">
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              </h4>
            </ng-container>
            <ng-container *ngSwitchCase="'h5'">
              <h5 class="app-dialog-title modal-title">
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              </h5>
            </ng-container>
            <ng-container *ngSwitchCase="'h6'">
              <h6 class="app-dialog-title modal-title">
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              </h6>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <h4 class="app-dialog-title modal-title">
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              </h4>
            </ng-container>
          </ng-container>
          <ng-template #headerTemplate>
            <i [ngClass]="iconclass" [ngStyle]="{width: iconwidth, height: iconheight, margin: iconmargin}"  *ngIf="iconclass && !iconurl"></i>
            <img data-identifier="img" [src]="iconurl" *ngIf="iconurl" [ngStyle]="{width:iconwidth, height:iconheight, margin:iconmargin}"/>
            <span class="dialog-heading" [textContent]="title" [id]="titleId"></span>
          </ng-template>
        </div>
        <div page-container-target  class="app-dialog-body modal-body" wmsTransclude>
          <ng-content></ng-content>
        </div>
        <div class="app-dialog-footer modal-footer" *ngIf="showactions">
          <button class="btn-primary ok-action btn app-button" aria-label="Submit button">{{oktext}}</button>
        </div>
      </div>
    </div>
  </div>
  `,
  providers: [
    provideAsWidgetRef(PageDialogComponent)
  ],
  exportAs: 'wmPageDialog',
  standalone: true,
  imports: [ CommonModule, WmsTranscludeDirective ],
  styles: []
})
export class PageDialogComponent extends StylableComponent {
  static initializeProps = register('wm-pagedialog');
  public titleId: string = 'wmdialog-' + generateGUId();

  override width:string;
  oktext: string;
  title: string;
  iconclass: string;
  iconurl: string;
  iconmargin: string;
  iconheight: string;
  iconwidth: string;
  showactions: boolean;
  class: string;
  loadDialogContent: boolean = false;
  headinglevel: string = 'h4';
  isPrism: boolean;

  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
    const projectService = runtimeEventManager.getService('projectService');
    this.isPrism = projectService.isPrism();
    this.registerPropertyChangeListener((key: string, nv: any, ov?: any) => {
      if (key === "height") {
        setCSS(this.nativeElement as HTMLElement, key, 'auto');
        const el = this.nativeElement.querySelector('.dialog-view .app-dialog') as HTMLElement;
        if (el) {
          setCSS(el, key, 'auto');
        }
      }else if (key === "width") {
        setCSS(this.nativeElement as HTMLElement, key, '100%');
      }
    })
  }
  override get stylerEl(): HTMLElement | null {
    return this.nativeElement.querySelector('.modal-dialog');
  }
  override ngOnInit() {
    super.ngOnInit();
    if(this.getAttr('title.bind')) {
      this.title='bind:'+this.getAttr('title.bind');
    }
    if(this.getAttr('oktext.bind')) {
      this.oktext='bind:'+this.getAttr('oktext.bind');
    }
  }
  override onStyleChange(key: string, nv: any, ov?: any) {
    if (key === 'height' && nv !== ov) {
      this.$element.find('.modal-body').css('height', nv);
    }
  }
}

